import CryptoJS from 'crypto-js';
import pako from 'pako';
import { Buffer } from 'buffer';

// 初始化 Buffer 給 React Native 使用
global.Buffer = global.Buffer || Buffer;

export function decryptApiPayload<T = any>(base64Encrypted: string, aesKey: string, aesIV: string): T {
    try {
        const KEY = CryptoJS.enc.Utf8.parse(aesKey);
        const IV = CryptoJS.enc.Utf8.parse(aesIV);

        // AES 解密
        const decrypted = CryptoJS.AES.decrypt(base64Encrypted, KEY, {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        const compressedBase64 = decrypted.toString(CryptoJS.enc.Base64);

        // Base64 decode → Uint8Array
        const compressedBytes = Uint8Array.from(
            Buffer.from(compressedBase64, 'base64')
        );

        // Gzip 解壓縮
        const decompressed = pako.ungzip(compressedBytes, { to: 'string' });

        return JSON.parse(decompressed);
    } catch (err) {
        console.error('解密失敗:', err);
        throw new Error('資料解密失敗');
    }
}

export function encryptApiPayload(payload: any, aesKey: string, aesIV: string): string {
    try {
        // 1. 序列化 + gzip 壓縮
        const jsonStr = JSON.stringify(payload);
        const compressed = pako.gzip(jsonStr);

        // 2. 轉成 Base64
        const base64 = Buffer.from(compressed).toString('base64');

        // 3. AES 加密
        const KEY = CryptoJS.enc.Utf8.parse(aesKey);
        const IV = CryptoJS.enc.Utf8.parse(aesIV);

        const encrypted = CryptoJS.AES.encrypt(base64, KEY, {
            iv: IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        return encrypted.toString();
    } catch (err) {
        console.error('加密失敗:', err);
        throw new Error('資料加密失敗');
    }
}

export function encodeGzipBase64Payload(obj: any): string {
    try {
        const json = JSON.stringify(obj);
        // 轉 Uint8Array
        const uint8 = new TextEncoder().encode(json);
        // Gzip 壓縮
        const compressed = pako.gzip(uint8);
        // base64 編碼
        const base64 = Buffer.from(compressed).toString('base64');
        return base64;
    } catch (error) {
        console.error('encodeGzipBase64Payload error:', error);
        return '';
    }
}

export function decodeGzipBase64Payload(base64: string): any {
    try {
        const compressed = Uint8Array.from(Buffer.from(base64, 'base64'));
        const decompressed = pako.ungzip(compressed);
        const json = Buffer.from(decompressed).toString('utf-8'); // ✅ 使用 Buffer 轉字串
        return JSON.parse(json);
    } catch (error) {
        console.error('decodeGzipBase64Payload error:', error);
        return null;
    }
}

export const compressData = (data: any[]): string => {
    const json = JSON.stringify(data);
    const compressed = pako.deflate(json);
    return Buffer.from(compressed).toString('base64');
};

export const decompressData = (encoded: string): any[] => {
    const compressed = Buffer.from(encoded, 'base64');
    const decompressed = pako.inflate(compressed, { to: 'string' });
    return JSON.parse(decompressed);
};